import type { Dispatch } from '@reduxjs/toolkit';
import type { NavigateFunction } from 'react-router-dom';
import type { UIPaymentGroups, UIPayoutGroups } from 'store/formatters';
import type {
  PayHubDomainSessionsEnumsPlatformType,
  PaymentProcessMethodInfo,
  PayoutProcessMethodInfo,
} from 'store/models';
import { setContentPageUrl } from 'store/slices/contentPage';

import { Routes } from '../Modulor/routes';
import type { FlowTypes } from '../store/constants';
import { getLinkTargetType, isContentPageUrl, transformContentUrl } from './locactionAndUrls';
import { internalNavigateBack } from './navigationControl';

export interface HandleSelectInfoMethodProps {
  methods: UIPaymentGroups[] | UIPayoutGroups[];
  currentMethod?: PayoutProcessMethodInfo | PaymentProcessMethodInfo;
  matchedMethod?: UIPaymentGroups | UIPayoutGroups;
  dispatch: Dispatch;
  platform?: PayHubDomainSessionsEnumsPlatformType;
  navigate: NavigateFunction;
  location: Location;
  payGroupId: number;
  isSuccess: boolean;
  flow: FlowTypes;
}

export const handleSelectInfoMethod = (props: HandleSelectInfoMethodProps): boolean => {
  const {
    methods,
    matchedMethod: matchedFromProps,
    currentMethod,
    dispatch,
    platform,
    navigate,
    location,
    payGroupId,
    flow,
  } = props;
  if (!currentMethod) return false;
  const matchedMethod = matchedFromProps ?? methods.find((method) => method.id === payGroupId);
  const descriptionUrl = currentMethod.info;
  const isSelfTarget = !!matchedMethod?.isSelfTarget;

  if (!descriptionUrl) {
    return false;
  }

  const transformedUrl = transformContentUrl(descriptionUrl);
  const isContentPage = isContentPageUrl(transformedUrl);
  const linkTarget = getLinkTargetType({
    platform,
    isSelfTarget,
  });

  const navigateMap = {
    _self: (): void =>
      navigate('/content', {
        replace: true,
        state: {
          from: flow === 'deposit' ? Routes.deposit : Routes.withdrawal,
          background: {
            pathname: Routes[flow],
            search: location.search,
          },
        },
      }),

    _blank: (): void => {
      window.open(transformedUrl, '_blank', 'noopener,noreferrer');
      internalNavigateBack(navigate);
    },
  };

  if (isContentPage && isSelfTarget) {
    dispatch(setContentPageUrl(transformedUrl));
  }

  navigateMap[linkTarget]();

  return true;
};
